// Slideshow functionality for front page
document.addEventListener('DOMContentLoaded', function() {
  const slides = document.querySelectorAll('.slideshow-slide');
  
  if (slides.length === 0) return; // No slideshow on this page
  
  let currentSlide = 0;
  let slideshowInterval = null;
  
  function showSlide(index) {
    // Remove active class from all slides to trigger fade-out
    slides.forEach(slide => {
      slide.classList.remove('active');
    });
    
    // Add active class to current slide to trigger fade-in
    slides[index].classList.add('active');
    
    // Update container height to match the active slide's content
    const container = slides[index].parentElement;
    const img = slides[index].querySelector('img');
    
    // Set height after image loads (or immediately if already loaded)
    if (img && !img.complete) {
      img.addEventListener('load', function() {
        container.style.height = slides[index].scrollHeight + 'px';
      }, { once: true });
    } else {
      container.style.height = slides[index].scrollHeight + 'px';
    }
  }
  
  function nextSlide() {
    currentSlide = (currentSlide + 1) % slides.length;
    showSlide(currentSlide);
  }
  
  // Show the first slide immediately
  showSlide(currentSlide);
  
  // Change slide every 5 seconds
  if (slides.length > 1) {
    slideshowInterval = setInterval(nextSlide, 5000);
  }
  
  // Clean up interval when page is unloaded
  window.addEventListener('beforeunload', function() {
    if (slideshowInterval) {
      clearInterval(slideshowInterval);
    }
  });
});
